import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { SubscriptionsQueryParams, SubscriptionsResponseData } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const SUBSCRIPTIONS_QUERY_KEY = 'subscriptions';

export const useSubscriptionsQuery = (props: SubscriptionsQueryParams) => {
  return useQuery({
    queryKey: [SUBSCRIPTIONS_QUERY_KEY, props.fetchUrl, props.queryParams],
    queryFn: () =>
      HttpClient.request<SubscriptionsResponseData>({
        method: 'GET',
        url: props.fetchUrl,
        params: props.queryParams,
      }),
    placeholderData: keepPreviousData,
  });
};
